"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var functions_exports = {};
__export(functions_exports, {
  bucketContains: () => bucketContains,
  bucketLabel: () => bucketLabel,
  bucketMaxValue: () => bucketMaxValue,
  bucketMinValue: () => bucketMinValue,
  findBucket: () => findBucket,
  findBucketIndex: () => findBucketIndex,
  findBuckets: () => findBuckets,
  isLookupBucket: () => isLookupBucket,
  isRangeBucket: () => isRangeBucket,
  multiBucketLabel: () => multiBucketLabel,
  rangeLabel: () => rangeLabel
});
module.exports = __toCommonJS(functions_exports);
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_attribute = require("../attribute/index.js");
function isLookupBucket(bucket) {
  switch (bucket.type) {
    case "LookupBucket":
      return true;
    case "RangeBucket":
      return false;
    default:
      return (0, import_util.checkExhausted)(bucket);
  }
}
function isRangeBucket(bucket) {
  switch (bucket.type) {
    case "LookupBucket":
      return false;
    case "RangeBucket":
      return true;
    default:
      return (0, import_util.checkExhausted)(bucket);
  }
}
function bucketMinValue(bucket) {
  return isLookupBucket(bucket) ? bucket.value : bucket.minValue;
}
function bucketMaxValue(bucket) {
  return isLookupBucket(bucket) ? bucket.value : bucket.maxValue;
}
function rangeLabel(attribute, minValue, maxValue, maxInclusive) {
  const minLabel = minValue == null ? null : (0, import_attribute.formatAttributeValue)(attribute, minValue);
  const maxLabel = maxValue == null ? null : (0, import_attribute.formatAttributeValue)(attribute, maxValue);
  if (minLabel != null && maxLabel != null) {
    if (minLabel === maxLabel) {
      return `${minLabel}`;
    } else if (maxInclusive) {
      return `${minLabel} to ${maxLabel}`;
    } else {
      return `${minLabel} to <${maxLabel}`;
    }
  } else if (minLabel != null) {
    return `\u2265${minLabel}`;
  } else if (maxLabel != null) {
    if (maxInclusive) {
      return `\u2264${maxLabel}`;
    } else {
      return `<${maxLabel}`;
    }
  } else {
    return null;
  }
}
function bucketLabel(attribute, bucket) {
  if (isLookupBucket(bucket)) {
    return bucket.label ?? (bucket.value != null ? joinNullableStrings([(0, import_attribute.formatAttributeValue)(attribute, bucket.value), (0, import_attribute.attributeUnit)(attribute)], " ") : null);
  } else {
    return bucket.label ?? joinNullableStrings(
      [rangeLabel(attribute, bucket.minValue, bucket.maxValue, bucket.maxInclusive), (0, import_attribute.attributeUnit)(attribute)],
      " "
    );
  }
}
function multiBucketLabel(attribute, buckets) {
  if (buckets.some(isLookupBucket)) {
    return buckets.map((bucket) => bucketLabel(attribute, bucket)).join(", ");
  } else {
    const minValues = buckets.map(bucketMinValue);
    const maxValues = buckets.map(bucketMaxValue);
    const minValue = minValues.includes(null) ? null : (0, import_lodash.min)(minValues) ?? null;
    const maxValue = maxValues.includes(null) ? null : (0, import_lodash.max)(minValues) ?? null;
    const maxInclusive = false;
    return rangeLabel(attribute, minValue, maxValue, maxInclusive);
  }
}
function bucketContains(bucket, value) {
  switch (bucket.type) {
    case "LookupBucket": {
      return bucket.value == null ? value == null : bucket.value === value;
    }
    case "RangeBucket": {
      const minBound = bucket.minValue == null ? true : value != null && bucket.minValue <= value;
      const maxBound = bucket.maxValue == null ? true : bucket.maxInclusive ? value != null && bucket.maxValue >= value : value != null && bucket.maxValue > value;
      return minBound && maxBound;
    }
    default:
      return (0, import_util.checkExhausted)(bucket);
  }
}
function findBucket(buckets, value) {
  return buckets.find((bucket) => bucketContains(bucket, value)) ?? null;
}
function findBucketIndex(buckets, value) {
  return buckets.findIndex((bucket) => bucketContains(bucket, value));
}
function findBuckets(buckets, values) {
  return buckets.filter((bucket) => values.some((value) => bucketContains(bucket, value)));
}
function joinNullableStrings(items, delim) {
  const strings = items.filter((item) => item != null);
  return strings.length === 0 ? null : strings.join(delim);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  bucketContains,
  bucketLabel,
  bucketMaxValue,
  bucketMinValue,
  findBucket,
  findBucketIndex,
  findBuckets,
  isLookupBucket,
  isRangeBucket,
  multiBucketLabel,
  rangeLabel
});
//# sourceMappingURL=functions.js.map
